import { render, staticRenderFns } from "./delimiter.vue?vue&type=template&id=4f661804&scoped=true&"
var script = {}
import style0 from "./delimiter.vue?vue&type=style&index=0&id=4f661804&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f661804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f661804')) {
      api.createRecord('4f661804', component.options)
    } else {
      api.reload('4f661804', component.options)
    }
    module.hot.accept("./delimiter.vue?vue&type=template&id=4f661804&scoped=true&", function () {
      api.rerender('4f661804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/profileSettings/include/delimiter.vue"
export default component.exports